import React from 'react'
import classNamesBind from 'classnames/bind'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  text: string
  noEndorse?: boolean
}
interface State {}

export default class Trait extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)
  }

  render() {
    const { text } = this.props

    return (
      <div className={css.trait}>
        <div className={css.text}>{text}</div>
        {this.renderEndorse()}
      </div>
    )
  }

  renderEndorse() {
    const { noEndorse } = this.props
    const type = 'D'

    if (!noEndorse) {
      return (
        <div className={css.endorseWrapper}>
          <div className={classNames('endorse', type)}>
            <img
              src="/static/share/images/unchecked-red.svg"
              className={css.icon}
            />
          </div>
        </div>
      )
    }
  }
}
